import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OrgNameModalComponent} from "./org-name-modal.component";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [OrgNameModalComponent],
  imports: [
    CommonModule, FormsModule,
    AlertMessageModule,
    ButtonModule
  ],
  exports: [OrgNameModalComponent]
})
export class OrgNameModalModule { }
